import GeoPageMap from './geoPageMap';

// eslint-disable-next-line no-unused-vars
const map = new GeoPageMap();
